import { GrStack } from "@jnpmedi/grebob/dist/components/layout/GrStack";
import { palette } from "@jnpmedi/grebob/dist/theme/palette";
import { FileDetailViewerProps } from "./FileDetailViewer";
import { FileDetailViewerPdfSection } from "./FileDetailViewerPdfSection";
import { PdfPageSpecType } from "./types";
import { DocumentAccessRequesterType } from "@maven-rest/docs/DocumentSigner.dto";

type FileDetailViewerRendererProps = Omit<FileDetailViewerProps, "baseZoom"> & {
  calcPage: PdfPageSpecType;
  zoom?: number;
};

export function FileDetailViewerRenderer(props: FileDetailViewerRendererProps) {
  const {
    docsPdf,
    fileId,
    token,
    zoom,
    accessToken,
    onMarkerClicked,
    signatures,
    documentAccessRequesterType = DocumentAccessRequesterType.Signer,
    latestDocumentId,
    documentSign,
    calcPage,
  } = props;
  const { page, width, height, top, baseWidth, baseHeight } = calcPage;

  return (
    <GrStack
      style={{
        position: "absolute",
        width: `${width}px`,
        height: `${height}px`,
        top: `${top}px`,
        border: `1px solid ${palette.grey025}`,
      }}
    >
      <FileDetailViewerPdfSection
        docsPdfId={docsPdf.id}
        fileId={fileId}
        page={page}
        zoom={typeof zoom === "number" ? zoom : 1.0}
        width={baseWidth}
        height={baseHeight}
        documentSign={documentSign}
        token={token}
        accessToken={accessToken}
        onMarkerClicked={onMarkerClicked}
        signatures={signatures}
        documentAccessRequesterType={documentAccessRequesterType}
        latestDocumentId={latestDocumentId}
      />
    </GrStack>
  );
}
